
import React from 'react';
export default function Blog002() {
  return (
    <section>
    <article>
    <h2>2. 08-07-2022</h2>
          <h3>Creating a text-based button game</h3>
          <p>
            Through my reading I have been suggested to create a Project Story.
            <br />
            This sounds both productive and useful. I like the idea as it will
            help me practice communicating about the work I am doing, while I am
            working on it. <br />
            To get started with this, I have an idea for a game. The core
            concept is relatively simple, I am hoping the execution will follow.
            <br />
            The image to the right is the basic layout concept. I in detail
            about the vision and goals of this project, click 'Initial Concept
            and Layout' below.
          </p>
          </article>

        <h4>Links</h4>
        <br />
        <ul>
          <li>
            <a
              href="projects/project-01a-Concept.html"
              title="Concept and Layout"
            >
              <strong><p>Initial Concept and Layout</p></strong></a
            >
          </li>
        </ul>
        </ section >
  )
}
